import { useCallback, useMemo } from "react";

import { Form, Input, Select } from "antd";

import { RVFormFloatingLabelWrap, BADGE_STATUS, RVLink, RVFormItem, RVStatusSelectOption } from "@regal-voice/ui";
import { AppPagePaths } from "App/routes/paths";
import { generateFormItemRequiredRules } from "Components/FormItems/Shared/Validators/InputValidators/InputValidators";

import { VoiceAIFormItemKeys } from "../constants";

const DEMO_OPTIONS = [
    {
        name: "Admissions Officer (ID# 12415)",
        state: "active",
        id: "1",
    },
    {
        name: "Collect Claims Info (ID# 3432)",
        state: "active",
        id: "2",
    },
    {
        name: "Gather Missing Zipcode (ID# 2345)",
        state: "active",
        id: "3",
    },
    {
        name: "Summarize Issue (ID# 12415)",
        state: "active",
        id: "3",
    },
];

const REQUIRED_RULE = generateFormItemRequiredRules("SMS AI Agent");

const ID_LABEL = "AI Agent Name";
const LINK_TEXT = "Edit AI Agent";

export function SMSAIFormItems(): JSX.Element {
    const form = Form.useFormInstance();

    const aiOptions = useMemo(() => {
        return DEMO_OPTIONS?.map((demo) => {
            const { name, state } = demo;
            const badgeStatus = state === "draft" ? BADGE_STATUS.PENDING : BADGE_STATUS.ACTIVE;
            const content = "Live";
            return {
                label: <RVStatusSelectOption name={name} badgeStatus={badgeStatus} badgeContent={content} />,
                value: demo.id,
            };
        });
    }, []);

    const handleSMSSelect = useCallback(
        (value: string) => {
            const fileName = DEMO_OPTIONS?.find((file) => file.id === value)?.name;
            form.setFieldValue(VoiceAIFormItemKeys.voiceAIName, fileName);
        },
        [form]
    );

    return (
        <>
            <RVFormFloatingLabelWrap
                showFormLabel
                name={VoiceAIFormItemKeys.voiceAIID}
                label={ID_LABEL}
                rules={REQUIRED_RULE}
                extra={<RVLink to={AppPagePaths.aiAgents} text={LINK_TEXT} />}
            >
                <Select options={aiOptions} onChange={handleSMSSelect} />
            </RVFormFloatingLabelWrap>
            <RVFormItem name={VoiceAIFormItemKeys.voiceAIName} hidden>
                <Input />
            </RVFormItem>
        </>
    );
}
